import React from "react";
import "./Css/About.css";
import img1 from "./Images/nagarik.jpg"
import img2 from "./Images/gram.jpg"
import img3 from "./Images/background.jpg"

const AboutVillage = () => {
  const villageData = [
    {
      id: 1,
      title: "नागरिक",
      value: "३९२४",
      img: img1,
    },
    {
      id: 2,
      title: "स्थापना",
      value: "९/८/१९५९",
      img: img2,
    },
    {
      id: 3,
      title: "गावाचे क्षेत्रफळ",
      value: "५५.५१ कि.मी.",
      img: img3,
    },
  ];

  return (
    <section className="village-section">
     <h2 className="village-title">आपल्या गावाबद्दल</h2>
<h4 className="village-subtitle">स्वच्छ तासगांव  सुंदर तासगांव</h4>
<p className="village-description">
  गावातील प्रत्येक नागरिकाचे सहकार्य हेच आपल्या विकासाचे मूळ आहे.  
  चला, मिळून आपले गाव स्वच्छ, स्मार्ट आणि आदर्श बनवू या.
</p>


      <div className="village-card-container">
        {villageData.map((item) => (
          <div key={item.id} className="village-card">
            <img src={item.img} alt={item.title} className="village-card-img" />
            <div className="village-card-content">
              <h3>{item.title}</h3>
              <p className="village-value">{item.value}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutVillage;
